var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"tw-flex tw-items-center",attrs:{"title":_vm.$t('last change')}},[_c('fa',{staticClass:"tw-mr-1",attrs:{"icon":_vm.icons.clock}}),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.lastModifiedStr))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }